import organisationApplicationQuestionTemplates from "./organisation-application-question-templates";

export const ORGANISATION_APPLICATION_QUESTION_TEMPLATES_NAMESPACE =
  "organisations/organisationApplicationQuestionTemplates";

export default organisationApplicationQuestionTemplates;
